import { AppBar, Grid, Toolbar } from '@mui/material'
import { useSelector } from 'react-redux'

import {
  Contacts,
  HamburgerDrawerButton,
  HamburgerDrawerMenu,
  LanguageSelectText,
  LoginMenuItem,
  UnauthorizedButton,
  UserDrawerMenuItems,
  VirtualBadge
} from './widgets'

import { sizing, useThemeMode } from '../../theme'
import { isDefined, notDefined } from '../../utils'
import { DisconnectedMenuItem } from './widgets/Disconnected'

export const Header = () => {
  const { profile } = useSelector((state) => state?.auth)
  const { connectionError } = useSelector((state) => state?.error)
  const { palette } = useThemeMode()

  const headerStyle = {
    '@media (min-width: 350px)': {
      height: `${sizing.header.height}px`
    },
    '@media (max-width: 349px)': {
      height: `${sizing.header.height * 0.8}px`
    },
    background: palette.headerColor,
    zIndex: '10',
    '& .MuiToolbar-root': {}
  }

  const toolbarStyle = {
    height: '100%',
    padding: '0px !important',
    wrapper: {
      height: '100%',
      width: '100%',
      position: 'relative'
    },
    controlContainer: {
      margin: '0',
      position: 'absolute',
      top: '50%',
      left: '50%',
      alignItems: 'center',
      transform: 'translate(-50%, -50%)'
    },
    userBadge: {
      paddingRight: '15px'
    }
  }

  const userBadge = isDefined(profile) ? <VirtualBadge {...profile} /> : <UnauthorizedButton disabled={connectionError} />

  let loginMenu = (
    <HamburgerDrawerMenu referrence="companion-side-menu">
      <LoginMenuItem />

      <Contacts />
    </HamburgerDrawerMenu>
  )

  if (connectionError) {
    loginMenu = (
      <HamburgerDrawerMenu referrence="companion-side-menu">
        <DisconnectedMenuItem />

        <Contacts />
      </HamburgerDrawerMenu>
    )
  } else if (!notDefined(profile)) {
    loginMenu = (
      <HamburgerDrawerMenu referrence="companion-side-menu">
        <UserDrawerMenuItems {...profile} referrence="companion-side-menu" />
        <Contacts />
      </HamburgerDrawerMenu>
    )
  }

  return (
    <AppBar data-component="companion-header" elevation={3} sx={headerStyle}>
      <Toolbar sx={toolbarStyle}>
        <Grid container sx={toolbarStyle.wrapper}>
          <Grid item xs={6} sx={toolbarStyle.wrapper}>
            <HamburgerDrawerButton referrence="companion-side-menu" />
            {loginMenu}
          </Grid>

          <Grid item xs={6} sx={toolbarStyle.wrapper}>
            <Grid
              container
              direction="row"
              justifyContent="end"
              sx={toolbarStyle.controlContainer}
            >
              {/* <Grid item> Todo: Multiple themes support
                <ThemeToggle />
              </Grid> */}
              <Grid item>
                <LanguageSelectText />
              </Grid>
              <Grid item sx={toolbarStyle.userBadge}>
                {userBadge}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  )
}
